import { useEffect } from 'react';
import utils from 'utils';

const useLogoutWeakUsers = () => {
  useEffect(() => {
    if (!utils.isRememberMeChecked() && !utils.getUserSession()) {
      utils.clearLocalStorage();
      utils.clearSessionData();
    }
  }, []);
};

export default useLogoutWeakUsers;
